import { useMemo } from 'react';

import { getMsUntilNextSecond } from '#shared';

import { usePollingQuery } from '../../usePollingQuery';
import { useGetAircraftStatusesQuery } from '../aircraftStatuses.api';
import { useStaleWhileEmpty } from '../useStaleWhileEmpty';

import type { AircraftStatus } from '#entities';
import type { PollingQueryResult } from '../types';

const TARGET_SECOND = 5;

const getAircraftStatusesDelay = () => getMsUntilNextSecond(TARGET_SECOND);

export const useQueryAircraftStatuses = (): PollingQueryResult<
  AircraftStatus[]
> => {
  const queryResult = useGetAircraftStatusesQuery(undefined, {
    pollingInterval: 0,
  });

  const pollingResult = usePollingQuery(queryResult, {
    getDelay: getAircraftStatusesDelay,
  });

  const stale = useStaleWhileEmpty(
    {
      data: pollingResult.data?.data ?? [],
      generatedAt: pollingResult.data?.generatedAt ?? null,
    },
    pollingResult.lastReceiveTime?.getTime() ?? null,
  );

  return useMemo(
    () => ({
      data: stale.data,
      generatedAt: stale.generatedAt,
      isStale: stale.isStale,
      validation: null, // TODO: add validation when schema validation is added
      isLoading: pollingResult.isLoading,
      isFetching: pollingResult.isFetching,
      isError: pollingResult.isError,
      error: pollingResult.error,
      lastSentTime: pollingResult.lastSentTime,
      lastReceiveTime: pollingResult.lastReceiveTime,
    }),
    [pollingResult, stale],
  );
};
